"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_ADDITIONAL_INFO_HEX = exports.COLOR_SUCCESS_HEX = exports.COLOR_WARNING_HEX = exports.COLOR_DANGER_HEX = void 0;
exports.COLOR_DANGER_HEX = "red";
exports.COLOR_WARNING_HEX = "darkorange";
exports.COLOR_SUCCESS_HEX = "green";
exports.COLOR_ADDITIONAL_INFO_HEX = "lightgray";
//# sourceMappingURL=colorConstants.js.map